import {
    CALENDAR_ROUTE,
    CALENDAR_SHIFT_ROUTE,
    CALENDAR_TRIAL_ROUTE,
    EVENTS_ROUTE,
    FINANCE_ROUTE,
    LEGAL_INFO_ROUTE,
    STAFF_ROUTE,
    PERFORMERS_ROUTE,
    STATISTICS_ROUTE,
    STUDENT_TAGS_ROUTE,
    STUDENTS_ROUTE,
    TEAMS_ROUTE,
    TUTOR_FINANCE_ROUTE,
    WORK_TGS_ROUTE,
} from '../../../../app/router/routes'
import { canViewShiftSection, FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant, IMy } from '../../../../entities/my'
import { ISection } from '../../model/types'

export const getSections = (my: IMy): ISection[] => {
    const sections: ISection[] = []

    const canOpenLessonCalendar = hasFeature(my, FEATURE_SECTIONS.CALENDAR)
    const canOpenTrialCalendar = hasFeature(my, FEATURE_SECTIONS.TRIAL_LESSONS)
        && hasFeature(my, FEATURES.TRIAL_LESSONS.CALENDAR_READ)

    if (canOpenLessonCalendar || canOpenTrialCalendar) {
        sections.push({
            title: CALENDAR_ROUTE.name,
            link: canOpenLessonCalendar ? CALENDAR_ROUTE.path : CALENDAR_TRIAL_ROUTE.path,
        })
    }

    if(canViewShiftSection(my)){
        sections.push({
            title: CALENDAR_SHIFT_ROUTE.name,
            link: CALENDAR_SHIFT_ROUTE.path,
        })
    }

    if (
        hasFeature(my, FEATURE_SECTIONS.EVENTS)
        && hasFeature(my, FEATURES.EVENTS.LIST)
    ) {
        sections.push({
            title: EVENTS_ROUTE.name,
            link: EVENTS_ROUTE.path,
        })
    }

    if (
        hasFeature(my, FEATURE_SECTIONS.STATISTICS)
        && hasFeature(my, FEATURES.STATISTICS.VIEW)
    ) {
        sections.push({
            title: STATISTICS_ROUTE.name,
            link: STATISTICS_ROUTE.path,
        })
    }

    if (
        hasFeature(my, FEATURE_SECTIONS.STUDENTS)
        && hasFeatureGrant(my, FEATURES.STUDENTS.LIST)
        && (
            hasFeatureGrant(my, FEATURES.STUDENTS.VIEW_FULL)
            || hasFeatureGrant(my, FEATURES.STUDENTS.VIEW_TUTOR)
        )
    ) {
        sections.push({
            title: STUDENTS_ROUTE.name,
            link: STUDENTS_ROUTE.path,
        })
    }

    if (hasFeature(my, FEATURE_SECTIONS.WORK_TGS) && hasFeature(my, FEATURES.WORK_TGS.LIST)) {
        sections.push({
            title: WORK_TGS_ROUTE.name,
            link: WORK_TGS_ROUTE.path,
        })
    }

    if (
        hasFeature(my, FEATURE_SECTIONS.TEAMS)
        && (hasFeature(my, FEATURES.TEAMS.READ) || hasFeature(my, FEATURES.TEAMS.MANAGE))
    ) {
        sections.push({
            title: TEAMS_ROUTE.name,
            link: TEAMS_ROUTE.path,
        })
    }

    if (hasFeature(my, FEATURE_SECTIONS.STUDENT_TAGS) && hasFeature(my, FEATURES.STUDENTS.TAGS_LIST)) {
        sections.push({
            title: STUDENT_TAGS_ROUTE.name,
            link: STUDENT_TAGS_ROUTE.path,
        })
    }

    if (
        hasFeature(my, FEATURE_SECTIONS.STAFF)
        && hasFeatureGrant(my, FEATURES.IDM.STAFF_LIST)
    ) {
        sections.push({
            title: STAFF_ROUTE.name,
            link: STAFF_ROUTE.path,
            group: 'bottom',
        })
        sections.push({
            title: PERFORMERS_ROUTE.name,
            link: PERFORMERS_ROUTE.path,
            group: 'bottom',
        })
    }

    if (hasFeature(my, FEATURE_SECTIONS.FINANCE)) {
        const financeRoute = my.role === 'tutor'
            ? TUTOR_FINANCE_ROUTE
            : FINANCE_ROUTE

        sections.push({
            title: financeRoute.name,
            link: financeRoute.path,
        })
    }

    if (hasFeature(my, FEATURES.LEGAL_INFO.READ) || hasFeature(my, FEATURES.LEGAL_DOCUMENTS.READ)) {
        sections.push({
            title: LEGAL_INFO_ROUTE.name,
            link: LEGAL_INFO_ROUTE.path,
        })
    }

    return sections
}
